import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import Measure from 'react-measure';
import { ToggleButton } from "../Button/ToggleButton/ToggleButton";
import styles from "./ReadMoreLess.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReadMoreLess = function ReadMoreLess(_ref) {
  var _children = _ref.children,
    _ref$more = _ref.more,
    more = _ref$more === void 0 ? 'Read more' : _ref$more,
    _ref$less = _ref.less,
    less = _ref$less === void 0 ? 'Read less' : _ref$less;
  var maskedHeight = 196; // Should match height set in 'content' class in ReadMoreLess.module.scss.

  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollHeight = _useState2[0],
    setScrollHeight = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var toggledClass = expanded ? 'expanded' : 'collapsed';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Measure, {
      bounds: true,
      scroll: true,
      onResize: function onResize(contentRect) {
        if (contentRect && contentRect.scroll) {
          setScrollHeight(contentRect.scroll.height);
        }
      },
      children: function children(_ref2) {
        var measureRef = _ref2.measureRef;
        return /*#__PURE__*/_jsx("div", {
          ref: measureRef,
          className: classnames(scrollHeight > maskedHeight ? styles.content : null, styles[toggledClass]),
          children: _children
        });
      }
    }), /*#__PURE__*/_jsx("div", {
      className: styles.button,
      children: scrollHeight > maskedHeight ? /*#__PURE__*/_jsx(ToggleButton, {
        iconPosition: "right",
        styleType: "default",
        onPress: function onPress() {
          setExpanded(!expanded);
        },
        className: styles.buttonToggle,
        children: expanded ? less : more
      }) : null
    })]
  });
};